import { inject } from 'mobx-react';
import * as React from 'react';

import { AnalyticsStore } from 'bernie-core';

import { ExitIntentModel } from 'models/common/common-types';

import { ToolbarType, UitkOverlayToolbar } from 'uitk-react-toolbar';
import { UitkDialog, UitkDialogAnimationType } from 'uitk-react-dialog';
import { UitkFigure } from 'uitk-react-images';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkLink } from 'uitk-react-link';
import { UitkSpacing, UitkSpacingProps } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';

export interface ExitIntentOverlayProps {
  exitIntent?: ExitIntentModel;
  handleDismiss?: () => void;
  analytics?: AnalyticsStore;
}

@inject('analytics')
export class ExitIntentOverlay extends React.Component<ExitIntentOverlayProps> {
  private closeBtnRef = null;
  public constructor(props) {
    super(props);
    this.closeBtnRef = React.createRef();
  }

  public componentDidMount() {
    this.setFocus();
  }

  private setFocus() {
    if (this.closeBtnRef && this.closeBtnRef.current && typeof this.closeBtnRef.current.focus === 'function') {
      this.closeBtnRef.current.focus();
    }
  }

  public render() {
    const { exitIntent, handleDismiss, analytics } = this.props;

    const toolbarAnalytics = analytics.setupTracker('ExitIntent', 'close exit intent pop up');

    const message = exitIntent.message;

    const couponSectionProps: UitkSpacingProps = {
      className: 'uitk-type-center',
      padding: { blockend: 'two' },
    };

    return (
      <UitkDialog animation={UitkDialogAnimationType.SLIDEUP}>
        <UitkFigure className="all-image-fit-cover" src={exitIntent.backgroundImageUrl} data-stid="exit-intent-background-image">
          <UitkOverlayToolbar type={ToolbarType.CLOSE} action={handleDismiss} buttonRef={this.closeBtnRef} analytics={toolbarAnalytics} />
          <UitkSpacing className="pwa-theme--color-white" padding={{ inline: 'twelve', blockend: 'six' }}>
            <UitkLayoutFlex direction="column" justifyContent="center">
              <div>
                <UitkLayoutFlexItem>
                  <UitkSpacing {...couponSectionProps}>
                    <div>
                      <img width="180" src={exitIntent.logoUrl} alt="Brand Logo" />
                    </div>
                  </UitkSpacing>
                </UitkLayoutFlexItem>
                <UitkLayoutFlexItem>
                  <UitkSpacing {...couponSectionProps}>
                    <p>
                      <UitkText size={600} weight="bold">
                        {message.headingOne}
                      </UitkText>
                      <UitkText size={600} weight="bold">
                        {message.headingTwo}
                      </UitkText>
                      <UitkText size={900} weight="bold">
                        {message.percentOff}
                      </UitkText>
                    </p>
                  </UitkSpacing>
                </UitkLayoutFlexItem>
                <UitkLayoutFlexItem>
                  <UitkSpacing {...couponSectionProps}>
                    <p>
                      <UitkText size={500}>{message.headingThree}</UitkText>
                      <UitkText size={700} weight="bold">
                        {message.couponCode}
                      </UitkText>
                    </p>
                  </UitkSpacing>
                </UitkLayoutFlexItem>
                <UitkLayoutFlexItem>
                  <UitkSpacing {...couponSectionProps}>
                    <p>
                      {/* The way this text is laid out is OK, because this feature is COMET-only for now. */}
                      <UitkText size={200} inline={true}>
                        {message.termsAndConditionsOne}
                      </UitkText>{' '}
                      <UitkLink inline={true} theme="inverse" size="small">
                        <a href={exitIntent.clickHereLinkUrl} target="_blank" rel="noopener">
                          {message.clickHere}
                        </a>
                      </UitkLink>{' '}
                      <UitkText size={200} inline={true}>
                        {message.termsAndConditionsTwo}
                      </UitkText>
                    </p>
                  </UitkSpacing>
                </UitkLayoutFlexItem>
              </div>
            </UitkLayoutFlex>
          </UitkSpacing>
        </UitkFigure>
      </UitkDialog>
    );
  }
}
